module.exports = __webpack_public_path__ + "img/acceptance.48b15396.svg";